import { ThemeEvents } from '@theme/events';

let sticky = null;
let product = null;

let els = {};

/* ----------------------------------------------------------
   DOM CACHE
---------------------------------------------------------- */

function buildStickyCache(){

  sticky = document.querySelector('sticky-add-to-cart');
  if(!sticky) return;

  els = {
    price: sticky.querySelector('.price'),
    compare: sticky.querySelector('.compare-at-price'),
    title: sticky.querySelector('.variant-title'),
    button: sticky.querySelector('.add-to-cart')
  };

}

/* ----------------------------------------------------------
   GET CURRENT VARIANT
---------------------------------------------------------- */

function getCurrentVariant(){

  const picker = document.querySelector('variant-picker');
  if(!picker) return null;

  const opts = [];

  picker.querySelectorAll('[data-input-id]:checked')
  .forEach(el=>{
    opts.push(el.value);
  });

  const key = opts.join('|');

  return product.variants.find(v =>
    v.options.join('|') === key
  );

}

/* ----------------------------------------------------------
   SUBSCRIPTION DETECT
---------------------------------------------------------- */

function isSubscription(){

  const w = document.querySelector('.kaching-subscriptions__widget');

  if(!w) return false;

  return !w.classList.contains('one-time-purchase-selected');

}

/* ----------------------------------------------------------
   MONEY FORMAT
---------------------------------------------------------- */

function money(cents){

  if(window.Currency?.formatMoney){
    return window.Currency.formatMoney(cents);
  }

  if(window.Shopify?.formatMoney){
    return window.Shopify.formatMoney(cents);
  }

  return (cents/100).toFixed(2);

}

/* ----------------------------------------------------------
   PRICE ENGINE
---------------------------------------------------------- */

function computePrice(v){

  const subscription = isSubscription();

  let price = v.price;
  let compare = v.compare_at_price;

  if(subscription && v.selling_plan_allocations?.length){

    const plan = v.selling_plan_allocations[0];

    price = plan.price;

    /* compare luôn là giá mua 1 lần */
    compare = v.price;

  }

  return {price,compare};

}

/* ----------------------------------------------------------
   UPDATE UI
---------------------------------------------------------- */

function updateSticky(){

  if(!sticky) return;

  const v = getCurrentVariant();
  if(!v) return;

  const {price,compare} = computePrice(v);

  if(els.price){
    els.price.textContent = money(price);
  }

  if(els.compare){

    if(compare && compare > price){
      els.compare.textContent = money(compare);
      els.compare.style.display='';
    }else{
      els.compare.style.display='none';
    }

  }

  if(els.title){
    els.title.textContent = v.public_title || v.title;
  }

}

/* ----------------------------------------------------------
   OBSERVE SUBSCRIPTION
---------------------------------------------------------- */

function observeSubscription(){

  const w = document.querySelector('.kaching-subscriptions__widget');
  if(!w) return;

  const mo = new MutationObserver(updateSticky);

  mo.observe(w,{
    attributes:true,
    attributeFilter:['class']
  });

}

/* ----------------------------------------------------------
   INIT
---------------------------------------------------------- */

function init(){

  const script = document.getElementById('ProductJson');
  if(!script) return;

  product = JSON.parse(script.textContent);

  buildStickyCache();

  updateSticky();

  document.addEventListener(
    ThemeEvents.variantUpdate,
    updateSticky
  );

  observeSubscription();

}

/* ----------------------------------------------------------
   SHOPIFY SECTION SAFE
---------------------------------------------------------- */

document.addEventListener('DOMContentLoaded',init);

document.addEventListener('shopify:section:load',init);